module.exports = __webpack_public_path__ + "img/error.4dc2f5f5.png";